import React, { Fragment } from 'react'
import DatePicker from '@components/Calendar'

import {
  inputLabel,
  Error,
  inputContainer,
  inputClass,
  inputSublabelClass,
  passWordVisibility,
  passwordNotVisible,
  passwordVisible,
  mdClass,
  boxClass,
  hasValue,
  underline,
  errorClass,
  selectOption,
  disabledClass,
  inputDate,
  calendarWrapper,
  calendarStyle,
  calendarPopperStyle,
  textInputWrap,
  subLabelClass,
  subLabelError,
} from './style'

class TextInput extends React.Component {
  state = {
    isEmptyValue: true,
    type: this.props.type,
    visible: false,
    isPopupCalendar: false,
  }

  toggle(target) {
    this.setState({
      [target]: !this.state[target],
    })
    this.toggleVisible(this.state.visible)
  }

  toggleVisible(condition) {
    let type = 'password'
    if (!condition) {
      type = 'text'
    }

    this.setState({
      type: type,
    })
  }

  componentDidMount() {
    let { type } = this.props
    type = type || 'text'

    this.setState({
      type: type,
    })
  }

  handleOnChange = e => {
    const { onChange, inputType } = this.props
    if (onChange) {
      onChange(e)
      this.setState({ isPopupCalendar: false })
    }
    if (e.target) {
      const val = e.target.value
      this.setState({
        isEmptyValue: val == '',
      })
    } else {
      this.setState({
        isEmptyValue: e == '',
      })
    }
  }

  handleOnKeyUp = e => {
    const { onKeyUp } = this.props
    if (onKeyUp) {
      onKeyUp(e)
    }
  }

  handleOnFocus = e => {
    const { onFocus } = this.props
    if (onFocus) {
      onFocus(e)
    }
  }

  handleOnBlur = e => {
    const { onBlur } = this.props
    if (onBlur) {
      onBlur(e)
    }
  }

  handleOnInput = e => {
    const { onInput } = this.props
    if (onInput) {
      onInput(e)
    }
  }

  renderTextInput = () => {
    const { materialDesign, placeholder, id, disabled, setRef, autocomplete, value, subLabel, isError } = this.props
    const { isEmptyValue, type } = this.state
    const inputType = type || 'text'

    return (
      <div className={textInputWrap}>
        <input
          style={this.props.type === 'password' ? { paddingRight: '5rem' } : {}}
          type={inputType}
          className={`${inputClass}
        ${materialDesign ? mdClass : boxClass} 
        ${isEmptyValue ? '' : hasValue}
        ${disabled ? disabledClass : ''} ${typeof subLabel !== 'undefined' ? inputSublabelClass : ''}`}
          id={id}
          ref={setRef}
          name={id}
          value={value}
          onChange={this.handleOnChange}
          onKeyUp={this.handleOnKeyUp}
          onInput={this.handleOnInput}
          onFocus={this.handleOnFocus}
          onBlur={this.handleOnBlur}
          placeholder={placeholder}
          disabled={disabled || false}
          autoComplete="off"
        />
        {subLabel && !isError && <i className={subLabelClass}>{subLabel}</i>}
      </div>
    )
  }

  renderTextArea = () => {
    const { materialDesign, placeholder, id, disabled, setRef, value, subLabel } = this.props
    const { isEmptyValue } = this.state

    return (
      <div className={textInputWrap}>
        <textarea
          className={`${inputClass}
        ${materialDesign ? mdClass : boxClass} 
        ${isEmptyValue ? '' : hasValue}
        ${disabled ? disabledClass : ''} ${typeof subLabel !== 'undefined' ? inputSublabelClass : ''}`}
          id={id}
          ref={setRef}
          name={id}
          cols="7"
          rows="7"
          onChange={this.handleOnChange}
          onKeyUp={this.handleOnKeyUp}
          onInput={this.handleOnInput}
          onFocus={this.handleOnFocus}
          onBlur={this.handleOnBlur}
          placeholder={placeholder}
          disabled={disabled || false}
          autofill="off"
        >
          {value}
        </textarea>
        {subLabel && <i className={subLabelClass}>{subLabel}</i>}
      </div>
    )
  }

  renderSelect = () => {
    const { materialDesign, placeholder, id, disabled, setRef, selectOptions, selected, value } = this.props
    const { isEmptyValue, type } = this.state

    return (
      <select
        className={`${inputClass} 
      ${materialDesign ? mdClass : boxClass} 
      ${isEmptyValue ? '' : hasValue}`}
        name={id}
        onChange={this.handleOnChange}
        onKeyUp={this.handleOnKeyUp}
        onInput={this.handleOnInput}
        onFocus={this.handleOnFocus}
        onBlur={this.handleOnBlur}
        disabled={disabled || false}
        value={value}
      >
        <option style={{ color: 'red' }} value="" disabled selected={!selected} hidden>
          {placeholder}
        </option>

        {selectOptions.map(option => (
          <>
            <option selected={selected == option.value} value={option.value}>
              {option.label}
            </option>
          </>
        ))}
      </select>
    )
  }

  inputDateOnClick = () => {
    if (!this.props.disabled) {
      this.setState({ isPopupCalendar: !this.state.isPopupCalendar })
    }
  }

  handleOnDateChangeRaw = e => {
    if (this.props.handleOnDateChangeRaw) {
      this.props.handleOnDateChangeRaw(e)
    }
  }

  renderDatePicker = () => {
    const {
      materialDesign,
      placeholder,
      id,
      disabled,
      setRef,
      selectOptions,
      selected,
      value: val,
      dateValue,
      error,
      renderElement,
    } = this.props
    const { isEmptyValue, type, isPopupCalendar } = this.state
    const CustomInput = ({ value, onClick }) => (
      <div>
        <input
          style={{ cursor: 'pointer' }}
          className={`${inputClass}
             ${materialDesign ? mdClass : boxClass} 
             ${isEmptyValue ? '' : hasValue}
             ${disabled ? disabledClass : ''}`}
          // onClick={this.inputDateOnClick}
          onClick={!disabled && onClick}
          value={val}
          placeholder={placeholder}
          readOnly
        />
        {renderElement ? renderElement : ''}
        {/* <span type="birthdate" onClick={this.inputDateOnClick}> <> */}
      </div>
    )
    return (
      <DatePicker
        id={id}
        name={id}
        type="datepicker"
        selected={dateValue}
        onChange={this.handleOnChange}
        onChangeRaw={this.handleOnDateChangeRaw}
        isError={error}
        maxDate={new Date()}
        customInput={<CustomInput />}
        popperClassName={calendarPopperStyle}
      />
    )
  }

  render() {
    const {
      materialDesign,
      className,
      placeholder,
      label,
      type: propsType,
      id,
      disabled,
      setRef,
      isError,
      errorClassName = '',
      errorMessage,
    } = this.props
    const { visible, isEmptyValue, type } = this.state
    const inputType = type || 'text'
    const errClass = `${errorClass} ${errorClassName}`
    return (
      <Fragment>
        <div className={`${inputContainer} ${className || ''} ${isError ? errClass : ''}`}>
          <div className={inputLabel}>{label}</div>
          {inputType === 'select' && this.renderSelect()}
          {inputType === 'datepicker' && this.renderDatePicker()}
          {inputType === 'textarea' && this.renderTextArea()}
          {inputType !== 'select' && inputType !== 'datepicker' && inputType !== 'textarea' && this.renderTextInput()}
          {isError && (
            <Error className="inputError" htmlFor={id}>
              {errorMessage}
            </Error>
          )}
          {propsType === 'password' && !isEmptyValue && (
            <div className={passWordVisibility}>
              {visible ? (
                <span className={passwordVisible} onClick={() => this.toggle('visible')} />
              ) : (
                <span className={passwordNotVisible} onClick={() => this.toggle('visible')} />
              )}
            </div>
          )}
        </div>
      </Fragment>
    )
  }
}

export default TextInput
